import { StoreStateInternal } from '../store/Store';

/* Cohort predicates: pure functions of store state, reading Entry rather than the URL. */

/** A user whose referral the backend confirmed. Everyone else is Direct. */
export function isReferred(state: StoreStateInternal): boolean {
  return state.entry.referral !== undefined;
}
